<template>
<div class="wrap">
    <!-- <div class="vieHead">
        <div class="wapLogo"><img src="@/assets/images/wap/wapLogo.png" alt=""></div>
        <div class="wapmore"><img src="@/assets/images/wap/more.png" alt=""></div>
    </div> -->
    <wedHd></wedHd>

    <div class="contentBox contentList swiperBox">
        <div class="bgColor"><img src="@/assets/images/wap/banner3.png" alt=""></div>

        <a class="devLopBtn" href="http://5gm.richinfo.cn/dist/index.html#/register" target="_blank">
            <img src="@/assets/images/wap/devLopBtn.png" alt="">
        </a>
        
    </div>



<div class="contentBox contentList">
    <div class="titleBox">合作模式</div>
    <div class="bgColor"><img src="@/assets/images/wap/sass.png" alt=""></div>
    <div class="bgColor"><img src="@/assets/images/wap/syhbs.png" alt=""></div>
</div>


<div id="relation" class="contentBox contentList">
    <div class="titleBox">联系我们</div>
    <div><img src="@/assets/images/wap/contentus.jpg" alt=""></div>
</div>

<div class="contentUsWrap">
    <div class="listItem">
        <span class="til"><img src="@/assets/images/wap/phone.png" alt="">商务合作：</span>
        <span class="ct">陈经理</span>
    </div>
    <div class="listItem">
        <span class="til"><img src="@/assets/images/wap/user.png" alt="">联系电话：</span>
        <span class="ct">4008-303-123</span>
    </div>
    <div class="listItem">
        <span class="til"><img src="@/assets/images/wap/email.png" alt="">工作邮箱：</span>
        <span class="ct">csp@richinfo.cn</span>
    </div>
    <div class="listItem">
        <span class="til"><img src="@/assets/images/wap/adress.png" alt="">办公地址:</span>
        <span class="ct">深圳市南山区科苑南路3176号彩讯科创中心</span>
    </div>
</div>


  <wedFt></wedFt>
 <!-- <div class="footBtn">
     <img src="@/assets/images/wap/footLogo.png" alt="">
     <p>版权所有 © 彩讯科技股份有限公司.All right reserved</p>
     <p>粤ICP备15050890号-2</p>
 </div> -->
</div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'

export default {
    components:{
        wedHd,
        wedFt,
    },
    name: 'wapHome',
    data(){
        return{
            'photo-o':'@/assets/images/wap/banner1.png',
            show: false
            // actions: [{ name: '选项一' }, { name: '选项二' }, { name: '选项三' }],
        }
    },
    methods:{
        moses(val){
            console.log(val)
        },
        onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;
      Toast(item.name);
    }
    }
}
</script>
<style scoped>

img{
    width: 100%;
}
p{
    margin: 0;
    padding: 0;
}
.bgColor{
    background-color: #23416c;
}
.contentUsWrap{
    width: 100%;
    border-radius: 10px 10px 0 0;
    background-color: #fff;
    padding: 30px 20px;
    box-sizing: border-box;
    margin-top: -0.6rem;
    position: relative;
    border-radius: 20px 20px 0 0 ;
}
.contentUsWrap .listItem{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 15px 0;
    
}
.contentUsWrap .listItem{
    display: flex;
}
.contentUsWrap .listItem .til{
    flex: 8;
    font-size: 0.37rem;
    color: #4D5865;
}
.contentUsWrap .listItem .til img{
    width: 0.48rem;
    height: 0.48rem;
    margin-right: 0.13rem;
    vertical-align: middle;
}
.contentUsWrap .listItem .ct{
    flex: 16;
    font-size: 0.37rem;
    color: #1C2A39;
}

.swiperBox{
    position: relative;
}
.swiperBox .devLopBtn{
    width: 181px;
    height: 57px;
    position: absolute;
    left: 5%;
    bottom: 56%;
}
.navTitle{
    padding: 20px 0 20px 20px;
    width: 100%;
    position: relative;
}
.navTitle::before{
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 16px;
    border-radius: 20px;
    background-color: #178EFB;
    left: 10px;
    top: 23px;
}
.conVideo{
    height: 500px;
    background-color: #000;
    margin: 20px;
}
/* .contentBoxVideo{
    padding-bottom: 20px;
} */
.contentBoxVideo .title{
    font-size: 17px;
    width: 100%;
    text-align: center;
}
.titleNav{
    padding: 10px;
    color: #8994A0;
}
.titleNav span{
    padding: 0 5px;
}


/* 底部黑色背景列表内容Start */
.footBtn{
    padding: 10px 20px;
    box-sizing: border-box;
    background: #2A2B2C;
}
.footBtn img{
    width: 100%;
    height: 43px;
}
.footBtn p{
    color: #F4F5F6;
    line-height: 25px;
    font-size: 12px;
    margin-top: 10px;
}
.van-cell::after{
    display: none;
}
.van-cell__right-icon{
    color: #fff;
}
.van-cell{
    background: none;
    color: #fff;
}
.navwrap{
    background: #2A2B2C;
    padding-top:10px;
    border-bottom: 1px solid #5C5D5E;
}
/* 底部黑色背景列表内容End */

.contentList{

}
.contentList .coreWrap{
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
}
.contentList .coreWrap li{
    background-color: #fff;
    border:1px solid #EDEEF0;
    width: 50%;
    box-sizing: border-box;
    text-align: center;
    /* height: 276px; */
    line-height: 276px;
    padding: 0;
}
/* .contentList .coreWrap li img{
    width: 188px;
    height: 171px;
} */
.coreWrap{
    background-color: #fff;
}
.coreWrap li{
    padding: 22px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.coreWrap li .comTex{
    flex: 1;
    margin-right: 20px;
}
.coreWrap li .comTex .title{
    color: #1C2A39;
    font-size: 16px;

}
.coreWrap li .comTex .texts{
    color: #4D5865;
    font-size: 12px;
    margin-top: 8px;
    line-height:20px;

}
.coreWrap li .conImg{
    width: 105px;
    height: 80px;
}
.coreWrap li .conImg img{
    width: 100%;
}
.wrap{
    background: #f4f5f6;
}
.vieHead{
    width: 100%;
    height: 50px;
    padding: 0 10px 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.wapLogo{
    width: 136px;
    height: 36px;
}
.wapLogo img,.wapmore img{
    width: 100%;
}
.wapmore{
    width: 25px;
    height: 25px;
}
.my-swipe img {

}

.contentBox{
    background: #fff;
    /* margin-top: 10px; */
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    border-bottom: 1px solid #EDEEF0;
}
</style>


// WEBPACK FOOTER //
// src/pages/wapDeveloper/index.vue